<div
    *ngIf="!isMobileShowcase"
    [class.active]="menuOpen$ | async"
    class="menu"
    data-sentry="creative-item-menu-open"
    (click)="openKebabMenu($event)">
    <ui-svg-icon icon="kebab"></ui-svg-icon>
</div>
